import styled from 'styled-components';
import { COLORS } from '../../constants/style/color';

export const ErrorModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${COLORS.ModalBackdrop};
`;

export const ErrorModalContent = styled.div`
  background: ${COLORS.White};
  box-shadow: 0px 2px 7px ${COLORS.CardShadow};
  border-radius: 6px;
  padding: 32px 42px;
  min-width: 440px;
  max-width: 515px;
  text-align: center;

  .error-icon {
    font-size: 48px;
    color: ${COLORS.Red};
    margin-bottom: 16px;
  }

  h5 {
    font-size: 18px;
    color: ${COLORS.Black};
    font-weight: 600;
    margin-bottom: 12px;
  }

  p {
    font-size: 14px;
    color: ${COLORS.Gray};
    line-height: 1.5;
    margin-bottom: 24px;
  }

  .error-modal-buttons {
    display: flex;
    justify-content: center;
    gap: 12px;

    button {
      font-size: 1.4rem;
      line-height: 1.6rem;
      padding: 0.8rem 1.6rem;
    }
  }
`;
